:host(.blue-background) {
  background:
    linear-gradient(180deg, #2d6ae0 0%, #1d50d5 100%), linear-gradient(0deg, #f4f6fd, #f4f6fd);
}

:host {
  position: fixed;
  width: 600px;
  height: 75vh;
  bottom: 30px;
  right: 30px;
  background: #f4f6fd;
  background: var(--bg-blue-manager);
  box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  z-index: 1000000;

  .hide {
    display: none !important;
  }

  .display {
    display: flex !important;
  }

  .overflow--hidden {
    overflow: hidden;
    height: 100%;
  }

  .header-incident-reset {
    display: flex;
    align-items: flex-end;
    margin-left: 20px;
  }

  .header-full {
    position: relative;
    display: block;
    width: 100%;
    height: 200px;

    .header-full-container {
      position: relative;
      width: 100%;
      max-width: 1000px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      height: 100%;
      flex-direction: column;

      &__avatar {
        max-height: 76px;
        max-width: 76px;
        width: 100%;
        height: 100%;
        object-fit: contain;
        margin-bottom: 10px;

        img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }

      &__title {
        color: #ffffff;
        font-size: 32px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 42px;
        text-align: center;
        text-shadow: 1px 2px rgba(0, 0, 0, 0.18);
      }

      &.blur {
        filter: blur(3px);
      }

      &__back {
        display: block;
        width: 20px;
        height: 20px;
        position: absolute;
        left: 140px;
        padding: 10px;
        // background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        cursor: pointer;
      }

      .header-new-question {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 6px;
        padding: 5px 10px;
        cursor: pointer;
        position: absolute;
        right: 140px;

        &__icon {
          img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            margin-right: 5px;
          }
        }

        &__text {
          color: #0098ff;
          color: var(--blue);
          font-size: 14px;
          letter-spacing: 0;
          line-height: 18px;
        }
      }
    }

    .header-full-bg {
      display: none;
      position: absolute;
      background: rgba(0, 0, 0, 0.3);
      height: 100%;
      width: 100%;
      top: 0;
    }

    &--scroll {
      transition: all 1s;
      height: 80px;

      .header-full-container {
        flex-direction: row;
      }

      .header-full-container__avatar {
        transition: all 1s;
        max-width: 40px;
        max-height: 40px;
        margin-right: 20px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .header-full-container__title {
        font-size: 30px;
      }

      .header-incident--full {
        margin-left: 20px;
        margin-top: 0;

        .header-incident__text {
          font-size: 12px;
        }

        .header-incident__icon {
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }

  .layout {
    position: relative;
    width: 100%;
    height: calc(100% - 70px);
    bottom: 0;
    right: 0;
    overflow: hidden;
    overflow-y: auto;
    z-index: 1000;
    padding: 25px 15px 15px 15px;
    box-sizing: border-box;

    &--white {
      background: #ffffff;
      background: var(--bg-primary);
    }

    &--hidden {
      overflow-y: hidden;
    }

    &--chat {
      padding: 0px 15px 15px 15px;
    }

    &--event {
      overflow: hidden;
    }

    &--full {
      height: calc(100% - 200px);
      display: flex;
      justify-content: center;
      margin: 0 auto;
      box-sizing: border-box;
      -ms-overflow-style: none;
      /* IE and Edge */
      scrollbar-width: none;
      /* Firefox */

      contact-module,
      faq-list-module,
      faq-item-module,
      bot-component {
        position: relative;
        width: 100%;
        max-width: 740px;
      }

      &.layout--contact {
        align-items: center;
      }

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &--scroll {
      height: calc(100% - 80px);
      padding-top: 0;

      contact-module {
        display: block;
        height: 100%;
      }
    }

    &--callmeback contact-module {
      height: 100%;
      max-width: unset !important;
      display: flex;
      flex-direction: column;
    }

    &--contact {
      display: flex;
      align-items: center;
      justify-content: center;

      &-list {
        align-items: flex-start;
      }

      &-mail,
      &-phone {
        contact-module {
          height: 100%;
        }
      }

      contact-module {
        width: 100%;
      }
    }

    &--contact-jelastic {
      contact-module {
        height: 100%;
      }
    }
  }

  .header {
    position: relative;
    height: 60px;
    display: flex;
    justify-content: center;
    padding: 10px 20px 0;
    //background: var(--bg-deep-blue);
    align-items: center;
    z-index: 10000;
    border-radius: 8px;

    background: linear-gradient(180deg, #2d6ae0 -381.46%, #1d50d5 100%), #ffffff;
    &.background-pro {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #0c3191 100%), #ffffff;
    }
    &.background-business {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #3a3652 100%), #ffffff;
    }

    &.background-transparent {
      background: transparent;
    }

    &--separator {
      //background: var(--bg-deep-blue);
      position: absolute;
      width: 750px;
      height: 50px;
      left: -75px;
      border-radius: 0 0 50% 50%;
      bottom: -10px;
      z-index: 1;
      box-shadow: 1px 5px 15px 0 rgba(0, 0, 0, 0.04);

      background: linear-gradient(180deg, #2d6ae0 -381.46%, #1d50d5 50%), #ffffff;
      &.background-pro {
        background: linear-gradient(180deg, #2d6ae0 -381.46%, #0c3191 50%), #ffffff;
      }
      &.background-business {
        background: linear-gradient(180deg, #2d6ae0 -381.46%, #3a3652 50%), #ffffff;
      }

      &.background-transparent {
        background: transparent;
        box-shadow: none;
      }
    }

    &__user {
      position: relative;
      z-index: 3;

      img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #0098ff;
        text-decoration: none;
        font-size: 12px;
      }
    }

    &__back {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 20px;
      z-index: 10000;

      img {
        width: 16px;
        height: 16px;
        object-fit: contain;
      }
    }

    &__close,
    &__refresh {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 20px;
      z-index: 10;

      img {
        width: 14px;
        height: 14px;
        object-fit: contain;
      }
    }

    &__refresh {
      color: #fff;
      right: 50px;

      img {
        filter: invert(66%) sepia(83%) saturate(2738%) hue-rotate(315deg) brightness(115%)
          contrast(92%);
        filter: var(--icon-salmon);
      }
    }
  }

  .header-incident {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    background: linear-gradient(90deg, #ff8500 0%, #fe4521 42.37%, #f72800 100%);
    padding: 5px 10px;
    cursor: pointer;
    position: absolute;
    left: 60px;
    z-index: 10001;
    transition: all 0.5s;

    &--no-back {
      transition: all 0.5s;
      left: 30px;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 18px;
        height: 18px;
        object-fit: contain;
        filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
          contrast(105%);
        filter: var(--icon-white);
        margin-right: 5px;
      }
    }

    &__text {
      color: #ffffff;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 18px;

      .mobile {
        display: none;
      }

      .desktop {
        margin-left: 5px;
      }
    }

    &--full {
      position: relative;
      left: 0;
      margin-top: 10px;
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                 RESPONSIVE                                 */
  /* -------------------------------------------------------------------------- */
  // Small devices (landscape phones, 576px and up)
  @media (max-width: 576px) {
  }

  // Medium devices (tablets, 768px and up)
  @media (max-width: 768px) {
    height: 100%;
    width: 100%;
    right: 0;
    bottom: 0;

    .header-incident {
      &__text {
        .desktop {
          display: none;
        }

        .mobile {
          display: block;
        }
      }
    }

    .header {
      &--separator {
        width: 200%;
        left: -50%;
      }
    }
  }

  // Large devices (desktops, 992px and up)
  @media (max-width: 992px) {
  }

  // Extra large devices (large desktops, 1200px and up)
  @media (max-width: 1200px) {
  }
}
